import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=6814327c&"
import script from "./MaterialChartCard.vue?vue&type=script&lang=js&"
export * from "./MaterialChartCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&id=6814327c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports